import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        misCoordenadas: ''
    },
    mutations: {
        actualizarCoordenadas(state) {
            state.misCoordenadas = '123'
        }
    },
    actions: {
        async obtenerUbicacionActual({ commit }) {
            let misCoordenadas = ''
            let Error= ''
            function handleSuccess(position) {
                console.log('position', position.coords)
                let vmisCoordenadas = position.coords.latitude + ", " + position.coords.longitude
                misCoordenadas = vmisCoordenadas
            }

            function handleError(error) {
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        Error = 'Has denegado el permiso de ubicación. Por favor habilítalo para continuar.';
                        break;
                    case error.POSITION_UNAVAILABLE:
                        Error = 'La información de ubicación no está disponible.';
                        break;
                    case error.TIMEOUT:
                        Error = 'La solicitud de ubicación ha tardado demasiado. Intenta nuevamente.';
                        break;
                    default:
                        Error = 'Error desconocido al obtener la ubicación.';
                }
            }
            //getlocation
            function getLocation() {
                const options = {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0
                };
                navigator.geolocation.getCurrentPosition(
                    handleSuccess,
                    handleError,
                    options
                );
            }
            //checkGeolocationSupport
            // console.log('check geo', navigator.geolocation)
            if (!navigator.geolocation) {
                Error = 'Tu navegador no soporta geolocalización';
                return;
            }

            //checkPermissionState
            try {
                console.log('checkPermissionState')
                // La API de Permissions no está disponible en todos los navegadores
                if (navigator.permissions && navigator.permissions.query) {
                    console.log('if ln 121')
                    const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });
                    console.log('if ln 123')
                    handlePermissionState(permissionStatus.state);
                    console.log('if ln 125', permissionStatus.state)
                    permissionStatus.onchange = () => handlePermissionState(permissionStatus.state);
                } else {
                    // Si no podemos verificar el estado, procedemos directamente
                    getLocation();
                }
            } catch (error) {
                console.error('Error al verificar permisos:', error);
                getLocation();
            }


            console.log('******** MIS COORDENADAS ',misCoordenadas)
            console.log('********ERROR ',Error)
            //llama a la mutación que actualiza state.miscoordenadas,
            commit('actualizarCoordenadas')
        }
    },
    getters: {
        getterCoordenadas(state) {
            return state.misCoordenadas
        }
    }
})